import { isKioskCallbackRole } from "../../utils/constants";

export const buildReceptionPresenceClinicIds = (roleId: string | undefined, todayClinic: number | Array<number> | undefined) => {
    const isBothClinicsUser = Array.isArray(todayClinic);
    const todayClinicIds = isBothClinicsUser ? todayClinic : [todayClinic];
    const canSeeCard = isBothClinicsUser || isKioskCallbackRole(roleId);

    const clinicIds = canSeeCard ? todayClinicIds.filter((clinicId): clinicId is number => typeof clinicId === "number") : [];
    return clinicIds;
};
